import { FaqState } from "./types";

/**
 * Initial state for the FAQ module.
 * Defaults to training data view with no active operations.
 */
const state: FaqState = {
  activeTab: "trainingData",
  intentSearch: "",
  backendSearch: "",
  backendSearchLoading: false,
  previewAutoClassify: [],
  arrayOfSelectedMessages: [],
  selectedConversationalDataIntent: "",
  selectedTopics: [],
  topics: [],
  trainingInProgress: false,
  publishingInProgress: false,
  currentViewingTopic: "",
  selectTrainTopicsDialogVisible: false,
};

export default state;
